import img1 from "../images/dentalapp/img1.jpg";
import img2 from "../images/dentalapp/img2.jpg";
import img3 from "../images/dentalapp/img3.jpg";
import img4 from "../images/dentalapp/img4.jpg";
import img5 from "../images/dentalapp/img5.jpg";
import img6 from "../images/dentalapp/img6.jpg";
import img7 from "../images/dentalapp/img7.jpg";
import img8 from "../images/dentalapp/img8.jpg";


export const imgDentalapp = [
  {
    id: 8101,
    image: img1
  },
  {
    id: 8102,
    image: img2
  },
  {
    id: 8103,
    image: img3
  },
  {
    id: 8104,
    image: img4
  },
  {
    id: 8105,
    image: img5
  },
  {
    id: 8106,
    image: img6
  },
  {
    id: 8107,
    image: img7
  } ,
  {
    id: 8108,
    image: img8
  }   
];